import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchCandidateSubjectConfigs = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.academic_year_id) queryParams.append('academic_year_id', params.academic_year_id);
  if (params.cluster_id) queryParams.append('cluster_id', params.cluster_id);
  if (params.standard_id) queryParams.append('standard_id', params.standard_id);
  if (params.institution_id) queryParams.append('institution_id', params.institution_id);

  const response = await fetch(`${API_BASE_URL}/candidates/subject-config?${queryParams.toString()}`, {
    method: 'GET',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const saveCandidateSubjectConfigs = async (data) => {
  const response = await fetch(`${API_BASE_URL}/candidates/subject-config`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteCandidateSubjectConfigs = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.academic_year_id) queryParams.append('academic_year_id', params.academic_year_id);
  if (params.cluster_id) queryParams.append('cluster_id', params.cluster_id);
  if (params.standard_id) queryParams.append('standard_id', params.standard_id);
  if (params.institution_id) queryParams.append('institution_id', params.institution_id);

  const response = await fetch(`${API_BASE_URL}/candidates/subject-config?${queryParams.toString()}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchCandidateResultConfig = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.academic_year_id) queryParams.append('academic_year_id', params.academic_year_id);
  if (params.cluster_id) queryParams.append('cluster_id', params.cluster_id);
  if (params.standard_id) queryParams.append('standard_id', params.standard_id);
  if (params.institution_id) queryParams.append('institution_id', params.institution_id);

  const response = await fetch(`${API_BASE_URL}/candidates/result-config?${queryParams.toString()}`, {
    method: 'GET',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const saveCandidateResultConfig = async (data) => {
  const response = await fetch(`${API_BASE_URL}/candidates/result-config`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const recalculateCandidateResults = async (data) => {
  const response = await fetch(`${API_BASE_URL}/candidates/recalculate`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const fetchCandidates = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.academic_year_id) queryParams.append('academic_year_id', params.academic_year_id);
  if (params.cluster_id) queryParams.append('cluster_id', params.cluster_id);
  if (params.standard_id) queryParams.append('standard_id', params.standard_id);
  if (params.cluster_institution_id) queryParams.append('cluster_institution_id', params.cluster_institution_id);
  if (params.institution_id) queryParams.append('institution_id', params.institution_id);
  if (params.institution_code) queryParams.append('institution_code', params.institution_code);
  if (params.search) queryParams.append('search', params.search);

  const response = await fetch(`${API_BASE_URL}/candidates?${queryParams.toString()}`, {
    method: 'GET',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createCandidate = async (data) => {
  const response = await fetch(`${API_BASE_URL}/candidates`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateCandidate = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/candidates/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteCandidate = async (id) => {
  const response = await fetch(`${API_BASE_URL}/candidates/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkUploadCandidates = async (data) => {
  const response = await fetch(`${API_BASE_URL}/candidates/bulk-upload`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const bulkDeleteCandidates = async (candidate_ids) => {
  const response = await fetch(`${API_BASE_URL}/candidates/bulk-delete`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ candidate_ids })
  });
  return handleResponse(response);
};
